import { Injectable } from '@angular/core';
import { environment } from '@environments';
import { ChangeApp } from 'experian-change-app-components';
import { Utils } from '../utils/utils';

interface IChangeApp {
  accessToken: string,
  env: string,
  targetClientId: string,
  originClientId: string,
};

@Injectable({
  providedIn: 'root',
})
export class MinitokenService {
  
  public generateMinitokenAndRedirect(redirectUrl: string, targetClientId: string): void {
    this.doChangeApp(targetClientId).then((response) => {
      const REDIRECT_URL = new URL(redirectUrl);

      if (response?.success) {
        const minitoken = response.data.minitoken;
        REDIRECT_URL.searchParams.append('minitoken', minitoken);

        window.open(REDIRECT_URL, '_blank');
      }
    });
  }

  public doChangeApp(targetClientId: string): Promise<{ success: boolean, data: { minitoken: string; }}> {
    const changeAppData: IChangeApp = {
      accessToken: Utils.getCookie('accessToken'),
      env: environment.env,
      targetClientId: targetClientId,
      originClientId: environment.clientId,
    };

    return ChangeApp.init(changeAppData);
  }

}
